import { useSnackbar } from "notistack";
import { useCallback, useEffect, useState } from "react";

import { Box } from "../../../../dtos/box";
import { AjaxResult } from "../../../../enums/ajaxResult";
import { useApi } from "../../../useApi";

export function useBox(boxId: number) {
    const { boxApi } = useApi();
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);
    const [box, setBox] = useState<Box | null>(null);

    const load = useCallback(() => {
        setLoading(true);
        boxApi.getById(boxId).then((r) => {
            if (r.result === AjaxResult.Success && r.data) {
                setBox(r.data)
            } else {
                enqueueSnackbar("Failed to load box data!", { variant: "error" });
            }
            setLoading(false);
        });
    }, [boxApi, boxId, enqueueSnackbar]);

    useEffect(() => {
        load();
    }, [load]);

    return { box, load, loading };
}
